<template>
  <div class="scorelist">
    <Header></Header>
    <div class="contain_main scoremain">
        <img src="../../assets/paper/scorelist.png" alt="">
        <div class="score">
            <table>
                <tr>
                    <td style="width:150px;">您本次考试得分：</td>
                    <td style="width:150px;"><Progress :percent="Number((Number(message.ehscore)*100/Number(message.epscore)).toFixed(1))" hide-info /></td>
                    <td style="width:100px;">{{message.ehscore}}分/{{message.epscore}}分</td>
                </tr>
                <tr>
                    <td>及格状态：</td>
                    <td>{{message.ehispass|jige}}</td>
                    <td></td>
                </tr>
                <!-- <tr>
                    <td>考题正确状况：</td>
                    <td><Progress :percent="25" hide-info /></td>
                    <td>20/50</td>
                </tr> -->
            </table>
        </div>
    </div>
    <div class="bottom">
        <div class="button" v-if="isshow" @click="tolist">返回考试列表</div>
        <!-- <div class="button" @click="torecord">查看试卷分析</div> -->
    </div>
  </div>
</template>
<script>
import Header from "../../components/header";
export default {
  name: "testlist",
  data() {
    return {
        message:null,
        isshow:true
    };
  },
  filters:{
      jige(value){
          switch(value){
              case 0:
              return '不及格'
              case 1:
              return '及格'
              case 2:
              return '未评分'
              default:
              return '未知'
          }
      }
  },
  beforeMount() {
      if(this.$route.params.message){
          this.message = this.$route.params.message
      }else{
          this.$router.push("/examlists")
      }
  },
  mounted(){
    if(window.sessionStorage.getItem('type')=='2'){
        this.isshow=false
    }
  },
  components: {
    Header
  },
  methods: {
      tolist(){
        this.$router.push("/examlists")
      },
      torecord(){
        // 取消

      }
  }
};
</script>
<style lang="css" scoped>
.scoremain,.bottom{
    display: flex;
    justify-content: space-around;
    margin-top: 70px;
}
.score{
    width: 400px;
    height: 400px;
    padding-top: 80px;
}
table{
    font-size: 16px;
    color: #575e6b;
}
tr{
    height: 60px;
}
tr td:first-child{
    text-align: right;
}
tr td:nth-child(2){
    text-align:left;
}
tr td:last-child{
    text-align:left;
}
.button{
  width: 1.4rem;
  height: 0.3rem;
  border-radius: 0.03rem;
  color: #fff;
  background: #5b61ff;
  font-size: 0.16rem;
  line-height: 0.3rem;
  margin: 0.22rem auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/testlists/scorelist.vue